import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseInventoryAdjustmentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/InventoryAdjustment/InventoryAdjustmentBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseInventoryAdjustment"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseInventoryAdjustment"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseInventoryAdjustmentActivity)
